import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { urlMapper } from '@shared/models';
import * as fromRootStore from '@store/index';
import { LogInfo } from '@store/index';
import {
  selectClientIncapacitated,
  selectPersonalDataLoaded,
} from '@store/selectors/personal-data/personal-data.selectors';
import { flowTypeSelection } from '@store/selectors/triage/triage.selectors';
import { CookieService } from 'ngx-cookie-service';
import { catchError, combineLatest, filter, Observable, of, switchMap } from 'rxjs';

@Injectable()
export class IncapacitatedGuard {
  constructor(
    private cookieService: CookieService,
    private router: Router,
    private globalStore: Store<fromRootStore.State>,
  ) {}

  canActivate(): Observable<boolean> {
    return this.cookieService.get('routeGuard') === 'OFF'
      ? of(true)
      : this.globalStore.select(selectPersonalDataLoaded).pipe(
          filter((loaded) => loaded),
          switchMap((_loaded) =>
            combineLatest([
              this.globalStore.select(selectClientIncapacitated),
              this.globalStore.select(flowTypeSelection),
            ]).pipe(
              switchMap(([incapacitated, flowType]) => {
                if (incapacitated) {
                  LogInfo({
                    payload: {
                      eventId: 'ineligible-page-route-incapacitatedGuard',
                      message: `Client has no access to the ${flowType} flow`,
                    },
                  });
                  this.router.navigate([`${urlMapper[flowType]}/ineligible`]);
                  return of(false);
                }
                return of(true);
              }),
            ),
          ),
          catchError(() => of(false)),
        );
  }
}
